
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/teaser",
      function () {
        return require("private-next-pages/components/teaser.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/components/teaser"])
      });
    }
  